var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { isSsr } from '../utils/general';
import { SSR_SESSION_STORAGE_KEY } from '../constants/general';
import { getFromStorage } from '../utils/storage-helper';
import { setReturnSession } from '../stores/returnStore';
export var useReturnSession = function () {
    var navigate = useNavigate();
    var _a = useState(), orderDetailsDataResponse = _a[0], setOrderDetailsDataResponse = _a[1];
    var fetchOrderDetailsData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var windowData, parsedData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(!isSsr && window.sessionStorage)) return [3 /*break*/, 2];
                    return [4 /*yield*/, getFromStorage(SSR_SESSION_STORAGE_KEY)];
                case 1:
                    windowData = _a.sent();
                    if (windowData) {
                        parsedData = JSON.parse(windowData)[0];
                        // order id is required, redirecting
                        if (!(parsedData === null || parsedData === void 0 ? void 0 : parsedData.orderId)) {
                            navigate('/myaccount/purchase-history', { replace: true });
                        }
                        setOrderDetailsDataResponse(parsedData);
                    }
                    else {
                        // Redirecting for no Session
                        navigate('/myaccount/purchase-history', { replace: true });
                    }
                    _a.label = 2;
                case 2: return [2 /*return*/, null];
            }
        });
    }); };
    var _b = orderDetailsDataResponse !== null && orderDetailsDataResponse !== void 0 ? orderDetailsDataResponse : {}, _c = _b.tenders, tenders = _c === void 0 ? [] : _c, orderDetailsDataV2 = _b.orderDetailsDataV2, orderId = _b.orderId, _d = _b.isGuest, isGuest = _d === void 0 ? false : _d, _e = _b.militaryExchange, militaryExchange = _e === void 0 ? '' : _e, _f = _b.orderBarcode, orderBarcode = _f === void 0 ? '' : _f, _g = _b.receiptNumber, receiptNumber = _g === void 0 ? '' : _g;
    var orderDetailsPath = (orderDetailsDataResponse === null || orderDetailsDataResponse === void 0 ? void 0 : orderDetailsDataResponse.orderDetailsPath) ||
        '/myaccount/order-details?orderNumber=' + orderId;
    var isMilitaryExchangeGuest = Boolean(militaryExchange) && isGuest;
    // Fetches order details data on render
    useEffect(function () {
        fetchOrderDetailsData();
    }, []);
    // If order details data is fetched, set the return session in the Store
    useEffect(function () {
        if (orderDetailsDataV2 && orderId) {
            setReturnSession({
                orderDetailsV2: orderDetailsDataV2,
                tenders: tenders,
                orderId: orderId,
                isMilitaryExchangeGuest: isMilitaryExchangeGuest,
                militaryExchange: militaryExchange,
                orderBarcode: orderBarcode,
                receiptNumber: receiptNumber,
                orderDetailsPath: orderDetailsPath,
            });
        }
    }, [orderDetailsDataResponse]);
    return {
        orderDetailsV2: orderDetailsDataV2,
        tenders: tenders,
        orderId: orderId,
        isMilitaryExchangeGuest: isMilitaryExchangeGuest,
        militaryExchange: militaryExchange,
        orderBarcode: orderBarcode,
        receiptNumber: receiptNumber,
        orderDetailsPath: orderDetailsPath,
    };
};
export default useReturnSession;
